<div
  id="sidebar"
  [class.collapsed]="isCollapsed"
  [class.expanded]="!isCollapsed">
  <div class="d-flex flex-row position__button">
    <button (click)="toggleSidebar()" class="nav-link text-white"
      aria-label="Toggle sidebar">
      <div class="d-flex flex-row align-items-center">
        <div
          class="ico__Close d-flex justify-content-center align-items-center">
          <img
            class="nav-icon ico__Close__Menu"
            [src]="
              isCollapsed
                ? '../../../../assets/img/MenuNormal.svg'
                : '../../../../assets/img/MenuCollapse.svg'
            "
            alt="" />
        </div>
      </div>
    </button>
  </div>
  <ul class="nav flex-column">
    <li class="nav-item" *ngFor="let category of categories">
      <a
        [routerLink]="category.url"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="nav-link text-white">
        <i [class]="category.etiqueta" aria-hidden="true" class="nav-icon"></i>
        <p class="nav-text m-0 ms-2">{{ category.nombre | translate }}</p>
      </a>
    </li>
  </ul>
</div>
